import { RootState } from '../types/rootstate'

export const agentIdSelector = (state: RootState) => state.activeConversation.agentId
export const agentNameSelector = (state: RootState) => state.activeConversation.agentName
